import formatCurrency from './formatCurrency';

/**
 * Used to format legend prices.
 *
 * @param {*} unit
 * @param {*} value
 */
export function formatUnitValue(unit, value) {
  return unit ? "".concat(value || 0, " ").concat(unit) : formatCurrency(value, 'usd');
}

/**
 * Gets a unit formatter for a unit.
 * @param {*} unit
 */
export function getUnitFormatter(unit) {
  return formatUnitValue.bind(null, unit);
}
//# sourceMappingURL=unitFormatter.js.map
